import { render, staticRenderFns } from "./RadioButtons.vue?vue&type=template&id=6053fd9c&scoped=true&"
import script from "./RadioButtons.vue?vue&type=script&lang=ts&"
export * from "./RadioButtons.vue?vue&type=script&lang=ts&"
import style0 from "./RadioButtons.vue?vue&type=style&index=0&id=6053fd9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6053fd9c",
  null
  
)

export default component.exports